import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-performance-marketing-hero" }
const _hoisted_2 = { class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 js-main-content _flexcol _gap-6" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_performance_marketing_start_box = _resolveComponent("performance-marketing-start-box")
  const _component_performance_marketing_why_section = _resolveComponent("performance-marketing-why-section")
  const _component_performance_marketing_faq_section = _resolveComponent("performance-marketing-faq-section")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, null, {
    default: _withCtx(() => [
      _createVNode(_component_footer_navigation, {
        "current-page": _ctx.Resources.Layout.PerformanceMarketingLink
      }, null, 8 /* PROPS */, ["current-page"]),
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "gfu-hd gfu-hd--d2 gfu-hd--decorative _tc--accent-inverse _mb-4" }, " Marketing with Adfound ", -1 /* CACHED */)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "gfu-become-creator-hero__content _mb-6" }, [
          _createTextVNode(" Elite marketing tool accessible to everyone."),
          _createElementVNode("br"),
          _createTextVNode(" An easy-to-use yet powerful marketing tool that allows you to run ad campaigns with the lowest commission and the best targeting, ensuring maximum impact for your project. ")
        ], -1 /* CACHED */)),
        _createVNode(_component_processing_button, {
          "is-processing": _ctx.isProcessing,
          theme: "accent",
          onClick: $options.onAction
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode(" Try Adfound ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["is-processing", "onClick"])
      ]),
      _createElementVNode("main", _hoisted_2, [
        _createVNode(_component_performance_marketing_start_box, {
          "is-processing": _ctx.isProcessing,
          "contact-url": $options.contactUrl,
          onAction: $options.onAction
        }, null, 8 /* PROPS */, ["is-processing", "contact-url", "onAction"]),
        _createVNode(_component_performance_marketing_why_section, {
          "contact-url": $options.contactUrl,
          onAction: $options.onAction
        }, null, 8 /* PROPS */, ["contact-url", "onAction"]),
        _createVNode(_component_performance_marketing_faq_section, { "contact-url": $options.contactUrl }, null, 8 /* PROPS */, ["contact-url"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}